import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * @private Internal usage only
 */
export var getTransBg = function getTransBg(size, colorFill) {
  return {
    backgroundImage: "conic-gradient(".concat(colorFill, " 0 25%, transparent 0 50%, ").concat(colorFill, " 0 75%, transparent 0)"),
    backgroundSize: "".concat(size, " ").concat(size)
  };
};

var genColorBlockStyle = function genColorBlockStyle(token, size) {
  var componentCls = token.componentCls,
      borderRadiusSM = token.borderRadiusSM,
      colorPickerInsetShadow = token.colorPickerInsetShadow,
      lineWidth = token.lineWidth,
      colorFillSecondary = token.colorFillSecondary;
  return _defineProperty({}, "".concat(componentCls, "-color-block"), Object.assign(Object.assign({
    position: 'relative',
    borderRadius: borderRadiusSM,
    width: size,
    height: size,
    boxShadow: colorPickerInsetShadow
  }, getTransBg('50%', token.colorFillSecondary)), _defineProperty({}, "".concat(componentCls, "-color-block-inner"), {
    width: '100%',
    height: '100%',
    border: "".concat(lineWidth, "px solid ").concat(colorFillSecondary),
    borderRadius: 'inherit'
  })));
};

export default genColorBlockStyle;